export * from "ce/api/JSActionAPI";
import { default as CE_JSActionAPI } from "ce/api/JSActionAPI";

class JSActionAPI extends CE_JSActionAPI {}

export default JSActionAPI;
